export default "__VITE_ASSET__ed3c6d36__"